interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "TJS";
};

const TJS: Currency = Object.freeze({
  "displayName": "Tajikistani Somoni",
  "numericCode": 972,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "TJS",
  "symbol": "ЅМ"
});

export { TJS };
